import { createAsyncAction } from "typesafe-actions";
import { deleteDayApi } from "./hours.api";
import {HoursDto} from './hours.dtos'

export const dayActions = createAsyncAction(
    'GET_DAY_REQUEST',
    'GET_DAY_SUCCESS',
    'GET_DAY_ERROR',
  )<string, HoursDto, string>();
  
  export const daysActions = createAsyncAction(
    'GET_DAYS_REQUEST',
    'GET_DAYS_SUCCESS',
    'GET_DAYS_ERROR',
  )<string, HoursDto[], string>();
  
  export const updateDayActions = createAsyncAction(
    'UPDATE_DAY_REQUEST',
    'UPDATE_DAY_SUCCESS',
    'UPDATE_DAY_ERROR',
  )<HoursDto, HoursDto, string>();
  
  export const createDayActions = createAsyncAction(
    'CREATE_DAY_REQUEST',
    'CREATE_DAY_SUCCESS',
    'CREATE_DAY_ERROR',
  )<HoursDto, HoursDto, string>();

  export const deleteDayAction = (day: HoursDto) => deleteDayApi(day);